export class OverrideSensitivityAnnotationsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sensitivityLevel",
            "baseName": "sensitivityLevel",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideSensitivityAnnotationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
